import React, { createContext, useContext, useState, useRef } from 'react';

const PlayerContext = createContext(null);

export const usePlayer = () => {
  const context = useContext(PlayerContext);
  if (!context) {
    throw new Error('usePlayer must be used within a PlayerProvider');
  }
  return context;
};

export const PlayerProvider = ({ children }) => {
  const [currentSong, setCurrentSong] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [queue, setQueue] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const audioRef = useRef(null);

  const playSong = (song, playlist = []) => {
    setCurrentSong(song);
    setIsPlaying(true);
    if (playlist.length > 0) {
      setQueue(playlist);
      const idx = playlist.findIndex(s => s.id === song.id);
      setCurrentIndex(idx >= 0 ? idx : 0);
    }
  };

  const pauseSong = () => {
    setIsPlaying(false);
  };

  const togglePlay = () => {
    setIsPlaying(!isPlaying);
  };

  const nextSong = () => {
    if (queue.length > 0 && currentIndex < queue.length - 1) {
      const next = queue[currentIndex + 1];
      setCurrentSong(next);
      setCurrentIndex(currentIndex + 1);
    }
  };

  const prevSong = () => {
    if (queue.length > 0 && currentIndex > 0) {
      const prev = queue[currentIndex - 1];
      setCurrentSong(prev);
      setCurrentIndex(currentIndex - 1);
    }
  };

  const addToQueue = (song) => {
    setQueue([...queue, song]);
  };

  const clearQueue = () => {
    setQueue([]);
    setCurrentIndex(0);
  };

  return (
    <PlayerContext.Provider value={{
      currentSong,
      isPlaying,
      queue,
      currentIndex,
      audioRef,
      playSong,
      pauseSong,
      togglePlay,
      nextSong,
      prevSong,
      addToQueue,
      clearQueue,
      setIsPlaying
    }}>
      {children}
    </PlayerContext.Provider>
  );
};

export default PlayerContext;
